module.exports = __webpack_public_path__ + "static/img/04.ead6655c.png";